import { render, staticRenderFns } from "./AppBack.vue?vue&type=template&id=62ead07a&"
import script from "./AppBack.vue?vue&type=script&lang=js&"
export * from "./AppBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports